import { createAsyncSlice } from 'store/createAsyncSlice';
import { sendAchPushAsync } from '../../../../../API/order/escrow/EscrowAPI';

export const { slice: sendAchPushSlice, asyncAction: sendAchPushAction } = createAsyncSlice(
  'sendAchPushSlice',
  sendAchPushAsync
);
